import { Component, OnInit, AfterViewInit } from '@angular/core';

export class TableExportConfig {
  title?: string;
  columns?: { [key: string]: string };
  cols?: Array<{ label: string, key: string }>;
  data?: Array<any>;
  onPrepared?: Function;
  print?: boolean = false;
}

@Component({
  selector: 'table-export-templete',
  templateUrl: './table-export-templete.component.html',
  styleUrls: ['./table-export-templete.component.less']
})
export class TableExportTempleteComponent implements OnInit, AfterViewInit {

  //表格导出配置
  public tableExportConfig: TableExportConfig = null;
  constructor() { }

  ngOnInit(): void {
    this.tableExportConfig = window["tableExportConfig"];
    this.tableExportConfig.cols = [];
    for (var key in this.tableExportConfig.columns) {
      this.tableExportConfig.cols.push({
        label: this.tableExportConfig.columns[key],
        key: key
      })
    }
  }

  ngAfterViewInit(): void {
    if (this.tableExportConfig.print) {
      window.print();
    }
    if (this.tableExportConfig.onPrepared != null) {
      this.tableExportConfig.onPrepared();
    }
  }
}
